import { render, staticRenderFns } from "./SpecificOpeningHours.vue?vue&type=template&id=dfd65c22&scoped=true&"
import script from "./SpecificOpeningHours.vue?vue&type=script&lang=js&"
export * from "./SpecificOpeningHours.vue?vue&type=script&lang=js&"
import style0 from "./SpecificOpeningHours.vue?vue&type=style&index=0&id=dfd65c22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd65c22",
  null
  
)

export default component.exports